export class Workflows {
  http;

  constructor(http) {
    this.http = http;
  }

  /**
   * List all workflows for the current organization
   */
  list = (params = {}) =>
    this.http.request({
      path: `/api/applications/workflows`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Get a specific workflow by ID
   */
  get = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Create a new application workflow
   */
  create = (data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows`,
      method: "POST",
      body: data,
      secure: true,
      type: "application/json",
      format: "json",
      ...params,
    });

  /**
   * Update an existing application workflow
   */
  update = (workflowId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: "application/json",
      format: "json",
      ...params,
    });

  /**
   * Delete a workflow
   */
  delete = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  // ==============================================================================
  // Canvas Graph Persistence Methods
  // ==============================================================================

  /**
   * Get the full visual canvas graph for a workflow (nodes, edges, viewport)
   */
  getCanvas = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}/canvas`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Save and persist the visual canvas graph (nodes, edges, viewport)
   */
  saveCanvas = (workflowId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}/canvas`,
      method: "PUT",
      body: data,
      secure: true,
      type: "application/json",
      format: "json",
      ...params,
    });

  // ==============================================================================
  // Market Templates Methods
  // ==============================================================================

  /**
   * List the catalog of pre-configured default workflow templates
   */
  listTemplates = (params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Retrieve the full visual canvas graph and transition rules for a specific template
   */
  getTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/templates/${templateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Instantiate a new application workflow cloned from a market template preset
   */
  createFromTemplate = (templateId, name, options = {}, params = {}) => {
    const body = typeof templateId === "object"
      ? templateId
      : { templateId, name, ...options };
    return this.http.request({
      path: `/api/applications/workflows/from-template`,
      method: "POST",
      body,
      secure: true,
      type: "application/json",
      format: "json",
      ...params,
    });
  };
}
